import React, { useMemo } from 'react';

import { Text } from '@mantine/core';
import AssignedToCell from 'pages/private/owner/Workouts/components/AssignedToCell';
import { CellProps, Column } from 'react-table';
import { WorkoutList } from 'types';
import { formatDateForDisplay } from 'utils/date-functions';

import ActionsCell from '../components/ActionsCell';
import WorkoutNameCell from '../components/WorkoutNameCell';

export interface WorkoutColumnsInput {
  permission: boolean;
  handlePreview: (workout: WorkoutList) => void;
  handleSaveAsTemplate: (workout: WorkoutList) => void;
  handleDelete: (workout: WorkoutList) => void;
}

export function useWorkoutsColumns({
  permission,
  handlePreview,
  handleSaveAsTemplate: handleDuplicate,
  handleDelete,
}: WorkoutColumnsInput): Column<WorkoutList>[] {
  return useMemo(
    (): Column<WorkoutList>[] => [
      {
        Header: 'Workout Name',
        accessor: 'name' as const,
        Cell: ({ row }: CellProps<WorkoutList>) => (
          <WorkoutNameCell workout={row.original} onPreview={handlePreview} />
        ),
      },
      {
        Header: 'Assigned To',
        accessor: 'kiloClassType' as const,
        Cell: ({ row }: CellProps<WorkoutList>) => <AssignedToCell workout={row.original} />,
      },
      {
        Header: 'Date',
        accessor: 'date' as const,
        Cell: ({ row }: CellProps<WorkoutList>) => (
          <Text>{formatDateForDisplay(row.original.date) ?? '-'}</Text>
        ),
      },
      {
        Header: 'Actions',
        id: 'action',
        Cell: ({ row }: CellProps<WorkoutList>) => (
          <ActionsCell
            workout={row.original}
            permission={permission}
            onPreview={handlePreview}
            onSaveAsTemplate={handleDuplicate}
            onDelete={handleDelete}
          />
        ),
        minWidth: 3.125,
        maxWidth: 3.125,
      },
    ],
    [permission, handlePreview, handleDuplicate, handleDelete],
  );
}
